import { render, staticRenderFns } from "./FivePage.vue?vue&type=template&id=7798c86f&scoped=true&"
import script from "./FivePage.vue?vue&type=script&lang=js&"
export * from "./FivePage.vue?vue&type=script&lang=js&"
import style0 from "./FivePage.vue?vue&type=style&index=0&id=7798c86f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7798c86f",
  null
  
)

export default component.exports